<script setup>
import { computed } from 'vue';
import { assetTypeMeta, platformMeta } from '../utils/mediaMeta';

const props = defineProps({
  asset: { type: Object, required: true },
});
defineEmits(['edit']);

const meta = computed(() => assetTypeMeta(props.asset.assetType));
const previewImage = computed(() => {
  const imgFile = props.asset.files?.find(f => /^image\//.test(f.contentType));
  return imgFile?.url;
});
const hasVideo = computed(() =>
  props.asset.files?.some(f => /^video\//.test(f.contentType))
);
</script>

<template>
  <button
    type="button"
    class="group relative w-full overflow-hidden rounded-lg border border-n-strong/30 bg-n-background text-left shadow-sm transition hover:border-blue-400 hover:shadow"
    @click="$emit('edit', asset)"
  >
    <div class="relative aspect-video w-full overflow-hidden bg-n-slate-2">
      <img
        v-if="previewImage"
        :src="previewImage"
        class="h-full w-full object-cover"
        alt=""
      />
      <div v-else class="flex h-full items-center justify-center">
        <span class="size-10 text-n-slate-11" :class="[meta.icon]" />
      </div>
      <span
        v-if="hasVideo"
        class="absolute inset-0 flex items-center justify-center bg-black/40"
      >
        <span class="i-lucide-play-circle size-10 text-white/90" />
      </span>
      <span
        class="absolute left-2 top-2 inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-bold uppercase text-white"
        :class="[meta.color]"
      >
        <span :class="meta.icon" class="size-2.5" />
        {{ meta.label }}
      </span>
    </div>

    <div class="p-2">
      <p class="truncate text-xs font-semibold text-n-slate-12">
        {{ asset.title }}
      </p>
      <div
        v-if="asset.platformTarget?.length"
        class="mt-1 flex flex-wrap gap-1"
      >
        <span
          v-for="p in asset.platformTarget"
          :key="p"
          class="inline-flex items-center gap-0.5 rounded px-1 py-0.5 text-[9px]"
          :class="[platformMeta(p).color]"
        >
          <span :class="platformMeta(p).icon" class="size-2.5" />
          {{ platformMeta(p).label }}
        </span>
      </div>
    </div>
  </button>
</template>
